import request from '@/utils/request';

// 查询locationDistrict列表
export function listLocationDistrict(query) {
  return request({
    url: '/ep2/locationDistrict/list',
    method: 'get',
    params: query,
  });
}

// 查询locationDistrict详细
export function getLocationDistrict(id) {
  return request({
    url: `/ep2/locationDistrict/${id}`,
    method: 'get',
  });
}

// 新增locationDistrict
export function addLocationDistrict(data) {
  return request({
    url: '/ep2/locationDistrict',
    method: 'post',
    data,
  });
}

// 修改locationDistrict
export function updateLocationDistrict(data) {
  return request({
    url: '/ep2/locationDistrict',
    method: 'put',
    data,
  });
}

// 删除locationDistrict
export function delLocationDistrict(id) {
  return request({
    url: `/ep2/locationDistrict/${id}`,
    method: 'delete',
  });
}
